import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import GenieTab from './GenieTab'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 80px;
  margin-top: 25px;
  margin-bottom:15px;
`
const TabBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`
const Divider = styled.div`
  height: 20px;
  width: 100%;
  border: 1px solid #bbbbbb;
  border-bottom-width: 0px;
  box-sizing: border-box;
`
const GenieTabs = ({ tabs, changeRole, currentRole }) => {
  return (
    <Container>
      <TabBar>
        {Array.from(tabs.entries()).map(tab => {
          const [role, title] = tab
          return (
            <GenieTab
              key={role}
              id={`${role}-genie-tab`}
              text={title}
              onClick={() => changeRole(role)}
              selected={role === currentRole}
            />
          )
        })}
      </TabBar>
      <Divider />
    </Container>
  )
}

GenieTabs.propTypes = {
  changeRole: PropTypes.func.isRequired,
  currentRole: PropTypes.string.isRequired,
  tabs: PropTypes.object.isRequired
}

export default GenieTabs
